var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-grow-1"},[_c('b-form-datepicker',{staticClass:"datepicker bg-transparent",class:{
			success: _vm.status === 'success' || _vm.status === 'valid',
			loading: _vm.status === 'loading',
		},attrs:{"locale":"pt-BR","label-help":"","date-format-options":{
			year: 'numeric',
			month: '2-digit',
			day: '2-digit',
		},"label-no-date-selected":"Selecionar","placeholder":"Nenhuma data selecionada"},on:{"input":_vm.onInput},model:{value:(_vm.updatableModel),callback:function ($$v) {_vm.updatableModel=$$v},expression:"updatableModel"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }